import styled from 'styled-components';

export const LinkButton = styled.button`
  outline: 0;
  border: 0;
  background: 0;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.darkBlue};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.primary.cyan};
  }
`;
